import React, { useState } from "react";

import { ToggleGroup, ToggleGroupItem } from "./ui/toggle-group";
import {
  X,
  ArrowDownToLine,
  ArrowUpFromLine,
  Plus,
  MoreVertical,
  ArrowRight,
} from "lucide-react";
import { Button } from "./ui/button";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogClose,
} from "./ui/dialog";
import TransactionHistorySingle from "./TransactionHistorySingle";
import withdrawIcon from "../assets/images/withdrawaIcon.svg";
import buyIcon from "../assets/images/buyIcon.svg";
import sendIcon from "../assets/images/sendIcon.svg";
import zarDeposit from "../assets/images/zarDeposit.svg";
import sellIcon from "../assets/images/sellIcon.svg";
import receiveIcon from "../assets/images/receiveIcon.svg";
import CurrencyFormatter from "../utils/currencyFormatter";
import { FormattedDate } from "../utils/dateFormatter";

function TransactionIcon({ type }) {
  const icons = {
    down: ArrowDownToLine,
    up: ArrowUpFromLine,
    plus: Plus,
  };
  const Icon = icons[type];

  return (
    <div className="w-12 h-12 rounded-full bg-pink-500 flex items-center justify-center text-white">
      <Icon className="w-6 h-6" />
    </div>
  );
}

const InvestTransactionHistoryAll = ({
  transactionsComplete,
  openAll,
  setOpenAll,
  onOpenSingle,
  asset,
  setIsFromAllTr,
}) => {
  const [selectedFilter, setSelectedFilter] = useState(""); // single value like "UserTrade|buy"

  const [selectedTransaction, setSelectedTransaction] = useState([]);
  const [singleTransaction, setSingleTransaction] = useState(false);

  const filterOptions = [
    { label: "Deposit", value: "deposit" },
    { label: "Withdrawal", value: "withdrawal" },
  ];

  const filteredTransactions = selectedFilter
    ? transactionsComplete.filter((tx) => tx.type === selectedFilter)
    : transactionsComplete;

  const handleSingleTransaction = (order) => {
    onOpenSingle?.(order);
    setIsFromAllTr(true);
    // setSelectedTransaction(order);
    // setSingleTransaction(true);
    // setOpenAll(false)
  };
  const formatter = new CurrencyFormatter();
  const dateFormat = new FormattedDate();
  return (
    <Dialog open={openAll} onOpenChange={setOpenAll}>
      <DialogTrigger asChild></DialogTrigger>
      <DialogContent className="max-w-[780px] rounded-2xl p-6  flex-1 flex flex-col">
        <DialogClose asChild>
          <Button
            variant="ghost"
            onClick={() => setOpenAll(false)}
            className="w-10 h-10 absolute top-4 right-4 text-gray-400 hover:text-gray-600 rounded-full p-0 flex items-center justify-center border border-gray-200 hover:bg-gray-100"
          >
            <X size={18} className="text-gray-700" />
          </Button>
        </DialogClose>

        <DialogHeader>
          <DialogTitle className="text-lg font-semibold text-gray-800">
            Transaction History
          </DialogTitle>
          <ToggleGroup
            type="single"
            value={selectedFilter}
            onValueChange={(value) => {
              setSelectedFilter(value || "");
            }}
            className="col-span-2 flex justify-start gap-2 bg-transparent rounded-full"
          >
            {filterOptions.map(({ value, label }, index) => (
              <ToggleGroupItem
                key={`${value}-${index}`}
                value={value}
                className={`rounded-full px-4 border ${
                  selectedFilter === value
                    ? "hover:bg-brand-primary/80 hover:text-white data-[state=on]:bg-brand-primary data-[state=on]:text-white"
                    : "bg-transparent hover:bg-gray-300 text-gray-600"
                }`}
              >
                {label}
              </ToggleGroupItem>
            ))}
          </ToggleGroup>
        </DialogHeader>

        <div className="mt-4 flex flex-col space-y-3 px-1 max-h-72 overflow-y-auto">
          {transactionsComplete &&
            filteredTransactions.map((transaction) => (
              <div key={transaction?._id} className="flex items-center gap-8">
                <div className="flex items-center gap-4">
                  {transaction.type === "withdrawal" && (
                    <img src={withdrawIcon} alt="" />
                  )}
                  {transaction.type === "deposit" && (
                    <img src={zarDeposit} alt="" />
                  )}
                  <div>
                    <div className="text-gray-900 font-medium">
                      {transaction.type &&
                        transaction.type.charAt(0).toUpperCase() +
                          transaction.type.slice(1).toLowerCase()}
                    </div>
                    <div className="text-gray-500 text-sm">
                      {dateFormat.simpleFormat(transaction.createdAt)}
                    </div>
                  </div>
                </div>
                <div className="flex items-center justify-end gap-12 flex-1">
                  <div className="flex">
                    <div className="text-gray-900 font-bold">
                      {formatter.format(
                        transaction.amount,
                        asset?.toUpperCase()
                      )}
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    {transaction.status && (
                      <div
                        className={`flex items-center gap-2 ${
                          transaction.status === "successful"
                            ? "bg-green-50"
                            : transaction.status === "pending"
                              ? "bg-yellow-50"
                              : "bg-red-50"
                        } px-3 py-1 rounded-full`}
                      >
                        <div
                          className={`w-2 h-2 rounded-full ${
                            transaction.status === "successful"
                              ? "bg-green-500"
                              : transaction.status === "pending"
                                ? "bg-yellow-500"
                                : "bg-red-500"
                          }`}
                        />
                        <span
                          className={`text-sm ${
                            transaction.status === "successful"
                              ? "text-green-500"
                              : transaction.status === "pending"
                                ? "text-yellow-500"
                                : "text-red-500"
                          }`}
                        >
                          {transaction.status &&
                            transaction.status.charAt(0).toUpperCase() +
                              transaction.status.slice(1).toLowerCase()}
                        </span>
                      </div>
                    )}
                  </div>
                  <Button
                    onClick={() => handleSingleTransaction(transaction)}
                    variant="outline"
                    size="icon"
                    className="rounded-full"
                  >
                    <ArrowRight className="w-5 h-5 text-gray-500" />
                  </Button>
                </div>
              </div>
            ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default InvestTransactionHistoryAll;
